import { create } from 'zustand'
import { useAuthStore } from './auth.store'

type SellerFilterState = {
  selectedSeller: string
  setSelectedSeller: (selectedSeller: string) => void
}

export const useSellerFilterStore = create<SellerFilterState>((set) => ({
  selectedSeller: '',
  setSelectedSeller: (selectedSeller) => set({ selectedSeller }),
}))

useAuthStore.subscribe((state, previous) => {
  if (
    state.token !== previous.token ||
    state.versionUrl !== previous.versionUrl
  ) {
    useSellerFilterStore.getState().setSelectedSeller('')
  }
})
